const cities = ['Salvador', 'Lauro de Freitas', 'Vila de Abrantes'];

const cityDropDownHelper = {
  cities,
};

export default cityDropDownHelper;
